import { render, staticRenderFns } from "./manageitems.vue?vue&type=template&id=11bdfb79&"
import script from "./manageitems.vue?vue&type=script&lang=js&"
export * from "./manageitems.vue?vue&type=script&lang=js&"
import style0 from "./manageitems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports